import styles from "./UserChatMessage.module.css";

interface Props {
    message: string;
    files?: string[];
}

export const UserChatMessage = ({ message, files }: Props) => {
    return (
        <div className={styles.container}>
            {files && files.length > 0 && (
                <div className={styles.attachments}>
                    {files.map((filename, i) => (
                        <span key={i} className={styles.attachment} title={filename}>
                            📎 {filename}
                        </span>
                    ))}
                </div>
            )}
            <div className={styles.message}>{message}</div>
        </div>
    );
};
